import { useFrameworkStore } from '@ukpostbox/frontend-framework/lib/Providers/Stores/FrameworkStore';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';

function BatchSignatureComplete(props: RenderBatchSectionType) {
	const { currentBatchData } = useForwardingBatchProvider();
	const theme = useFrameworkStore((state) => state.theme);

	return (
		<div>
			<h5 className='mb-xs'>
				{props.complete ? props.section.name : `Step ${props.sectionIndex}: ${props.section.name}`}
			</h5>

			{currentBatchData?.signature && (
				<img
					src={currentBatchData?.signature.value}
					alt='Selected Signature'
					style={{ filter: theme === 'dark' ? 'invert(1)' : 'none' }}
				/>
			)}
		</div>
	);
}

export { BatchSignatureComplete };
